// react-scan must be initialized before React loads.
// index.js is the webpack entry point and never re-executes on HMR,
// so this is the safest place for one-time setup that patches React internals.
import { Config, validateConfig } from '@genial/config';
import { registerRootComponent } from 'expo';
import { LogBox, Platform } from 'react-native';
import { scan } from 'react-scan';

import App from './App';

// Fail fast on missing/invalid environment configuration before the app boots.
validateConfig();

const reactScanEnabled = Config.ReactScanEnabled === 'true';
scan({
  enabled: reactScanEnabled,
  showFPS: reactScanEnabled,
  showToolbar: reactScanEnabled,
  dangerouslyForceRunInProduction: reactScanEnabled,
});

const logsToIgnore = ['BackHandler is not supported on web and should not be used.'];

if (Platform.OS === 'web') {
  // LogBox is not available on web, so we patch console.error directly.
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (logsToIgnore.some((log) => args[0].includes(log))) {
      return;
    }
    originalConsoleError(...args);
  };
} else {
  LogBox.ignoreLogs(logsToIgnore);
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
